# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedCourseList extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedCourseListModule'
#
#   @selector: ".featured_course_list_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedCourseList.register()
